<template>
  <div class="day-event" :class="{'is-opened': isOpen, 'is-done': isDone}">
    <div class="columns is-multiline has-bg-white">
      <div class="column is-narrow w90p is-padding-right-large has-text-right is-border-right columns is-vcentered">
        <div class="columns">
          <p>old</p>
          <p class="is-margin-top-xsmall has-text-centered">
            <time :datetime="date.format('DD-MMMM-YYYY')">
              <b>{{event.date | prettyTime}}</b>
            </time>
            <br>
            <time :datetime="date.format('DD-MMMM-YYYY')" v-if="event.end_date">
              <span class="is-size-6">{{event.end_date | prettyTime}}</span>
            </time>
          </p>
          <span class="dot is-medium"
                :class="{'has-bg-success': event.successful,'has-bg-warning': event.deferred, 'has-bg-danger': event.canceled, 'is-border has-bg-white': !isDone}">
            <span class="icon is-small has-text-white" v-if="isReported"><i
              class="fas fa-xs fa-check-circle"></i></span>
          </span>
        </div>
      </div>

      <!-- Body Rdv -->
      <div class="column is-paddingless">
        <div class="is-padding">
          <div>
            <b>{{event.rdv_type}}</b>&nbsp;-&nbsp;<span class="is-uppercase"><b>
            <router-link
              :to="{name: 'ContactVue', params: {id: event.contact}, query: {returnId: event.pk, page: page}}">{{event.contact_name}}</router-link></b></span>
          </div>
          <div class="columns">
            <div class="column is-paddingless is-narrow">
              Participant(s) :&nbsp;
            </div>
            <div class="column is-paddingless">
              <p>
                <router-link v-if="event.seller === currentUserPk || isManager || isAdmin || isSectorManager"
                             :to="{name: 'UserVue', params: {id: event.seller === currentUserPk ? 'me' : event.seller}, query: {returnId: event.pk, page: page}}">
                  {{myCalendarStatus === 'Participant' ? 'Vous' : event.seller_name}}
                </router-link>
                <span v-else>
                  {{event.seller_name}}
                </span>
                <em class="has-text-grey">(Organisateur<span v-if="event.author !== event.seller">: {{event.author_name}}</span>)</em>
              </p>
              <p v-if="event.guests && event.guests.length" v-for="(guest, i) in event.guests" :key="i">
                <router-link v-if="event.guest === currentUserPk || isManager || isAdmin || isSectorManager"
                             :to="{name: 'UserVue', params: {id: guest === currentUserPk ? 'me' : guest}, query: {returnId: event.pk, page: page}}">
                  {{guest === currentUserPk ? 'Vous' : event.guests_name[i]}}
                </router-link>
                <span v-else>{{event.guests_name[i]}} </span>
                <em class="has-text-grey"> - Invité</em>
              </p>
            </div>
          </div>
          <div class="is-padding-top-xsmall"
               v-if="event.address && (event.address.line1 !== null || event.address.zip_code !== null || event.address.city !== null)">
            <span class="icon is-small">
              <i class="fas fa-map-marked-alt" :class="{'fa-spinner fa-spin':loading}"></i>
            </span>
            <a @click="getCurrentLocation" class="is-padding-left-xsmall">
              {{event.address.line1}} {{event.address.zip_code}} {{event.address.city}} <em>(Itinéraire)</em>
            </a>
          </div>
          <div v-if="event.note" class="is-padding-top-xsmall">
            <b>Note : </b><span class="is-italic" v-html="event.note"></span>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="column is-narrow is-self-centered actions is-pos-left" v-if="isExported && !canEdit">
        <a class="actions-btn-disinherit is-transform-none button is-small is-danger is-circle"
           @mouseenter="tooltip = true" @mouseleave="tooltip = false" @click="makeGoogleLogin">
          <span class="icon is-small"><i class="fab fa-google is-size-5"></i></span>
        </a>
        <span class="c_tooltip tooltip-left is-light tooltip-500 is-shadowless" :class="{'active': tooltip}">
          <div class="tooltip-inner">
            <div class="column content is-padding-small is-size-6">
              <b class=""><em>Rendez-vous synchronisé par l'utilisateur : {{event.exported_by_name}}</em></b><br>
              <span v-if="!googleLogged">Veuillez vous connecter.</span>
            </div>
          </div>
        </span>
      </div>
      <div class="column is-narrow is-self-centered actions is-pos-left"
           :class="{'is-active' : activeActionsMenu}" v-else-if="!displayActionButton">
        <button aria-haspopup="true" aria-controls="actions-menu" :id="`${event.pk}'-action-menu'`"
                @click="activeMenu"
                v-if="!askDelete && canEdit"
                class="actions-tigger button is-small is-circle">
          <i class="far fa-ellipsis-h"></i>
        </button>
        <button aria-haspopup="true" aria-controls="actions-menu" :id="`${event.pk}'-action-menu'`"
                @click="askDelete = !askDelete"
                v-if="askDelete"
                class="actions-tigger button is-small is-circle">
          <i class="far fa-times"></i>
        </button>
        <div id="actions-menu" role="menu" class="actions-menu">
          <div class="field is-grouped">
            <div class="control" v-if="!askDelete && !canExport">
              <a class="actions-btn-disinherit is-transform-none button is-small is-danger is-circle"
                 @mouseenter="tooltip = true" @mouseleave="tooltip = false">
                <span class="icon is-small"><i class="fab fa-google is-size-5"></i></span>
              </a>
              <span class="c_tooltip tooltip-left is-light tooltip-500 is-shadowless" :class="{'active': tooltip}">
                <div class="tooltip-inner">
                  <div class="column content is-padding-small is-size-6">
                    <b><em>Rendez-vous synchronisé par l'utilisateur : {{event.exported_by_name}}</em></b>
                    <span v-if="!isInMyCalendar || !canEdit"><br>{{canEdit ? 'Exportation' : 'Modification'}} impossible.</span>
                  </div>
                </div>
              </span>
            </div>
            <div class="control" v-if="!askDelete && !displayQualif">
              <a v-if="isValidRdv" @click="openEvent('qualification')"
                 class="actions-btn-disinherit is-transform-none button is-rounded is-small"
                 :class="!isOpen || mode !== 'qualification' ? 'is-grey is-outlined' : 'is-black'">
                <span class="icon is-small"><i class="fas fa-calendar-check is-size-5"></i></span><span>{{!isReported ? 'Qualifier' : 'Compte rendu'}}</span>
              </a>
            </div>
            <div class="control" v-if="!askDelete && canExport">
              <a @click="openEvent('export')"
                 class="actions-btn-disinherit is-transform-none button is-rounded is-small"
                 :class="!isOpen || mode !== 'export' ? 'is-grey is-outlined' : 'is-black'">
                <span class="icon is-small"><i class="fas fa-upload is-size-5"></i></span><span>Exporter vers votre agenda</span>
              </a>
            </div>
            <div class="control" v-if="!askDelete && canEdit">
              <a @click="editRdv" class="actions-btn-disinherit button is-grey is-outlined is-circle is-small"><span
                class="icon is-small"><i class="fas fa-pencil is-size-5"></i></span></a>
            </div>
            <div class="control" v-if="askDelete">
              <a @click="deleteEvent" class="actions-btn-disinherit button is-danger is-small is-rounded">
                <span class="icon is-small"><i
                  class="fas fa-trash is-size-5"></i></span><span>Confirmer suppression</span>
              </a>
            </div>
            <div class="control" v-if="!askDelete && canEdit">
              <a @click="askDelete = !askDelete"
                 class="actions-btn-disinherit button is-grey is-outlined is-circle is-small"><span
                class="icon is-small"><i class="fas fa-trash is-size-5"></i></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit -->
    <div class="day-eventactions"
      :class="{'is-border-top is-border-dashed': ((isDone || displayQualif || isOpen) && mode !== null)}"
    >
      <div class="dayeventactions-actions" v-if="showQuali">
        <div class="columns is-gapless">
          <div class="column is-narrow is-border-right control has-bg-white">
            <label class="checkbox checkRadioIsHide" :for="'qualify-successful-'+eventPk"
                   @click="isDone || qualifyRdv('successful')">
              <input type="radio" value="successful" :name="'qualify-successful-'+eventPk"
                     :id="'qualify-successful-'+eventPk"
                     v-model="qualification" :disabled="isDone && canEdit">
              <span class="tag is-large is-radiusless is-white is-padding-left is-padding-right"
                    :class="{'is-success' : (qualification === 'successful' || event['successful'] === true)}">
                <span class="is-size-5">Effectué</span>
              </span>
            </label>
          </div>

          <div class="column is-narrow is-border-right control has-bg-white">
            <label class="checkbox checkRadioIsHide" :for="'qualify-deferred-'+eventPk"
                   @click="isDone || qualifyRdv('deferred')">
              <input type="radio" value="deferred" :name="'qualify-deferred-'+eventPk" :id="'qualify-deferred-'+eventPk"
                     v-model="qualification" :disabled="isDone && canEdit">
              <span class="tag is-large is-radiusless is-white is-padding-left is-padding-right"
                    :class="{'is-warning' : (qualification === 'deferred' || event['deferred'] === true)}">
                <span class="is-size-5">Reporté</span>
              </span>
            </label>
          </div>

          <div class="column is-narrow is-border-right control has-bg-white">
            <label class="checkbox checkRadioIsHide" :for="'qualify-canceled-'+eventPk"
                   @click="isDone || qualifyRdv('canceled')">
              <input type="radio" value="canceled" :name="'qualify-canceled-'+eventPk" :id="'qualify-canceled-'+eventPk"
                     v-model="qualification" :disabled="isDone && canEdit">
              <span class="tag is-large is-radiusless is-white is-padding-left is-padding-right"
                    :class="{'is-danger' : (qualification === 'canceled' || event['canceled'] === true)}">
                <span class="is-size-5">Annulé</span>
              </span>
            </label>
          </div>
          <div class="control rdv-button" v-if="edit">
            <a class="button is-square is-success is-border is-min-width-0 has-hover-black" @click="updateItem(qualification)">
              <span class="icon"><i class="fas fa-save"></i></span>
            </a>
          </div>
          <div class="control rdv-button is-border-right" v-if="edit">
            <a class="button is-square is-light is-border is-min-width-0" @click="cancelEditItem">
              <span class="icon"><i class="fas fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>

      <!-- Export buttons -->
      <div class="dayeventactions-actions" v-else-if="isOpen && mode === 'export'">
        <div class="columns is-gapless">
          <div class="column is-narrow is-border-right control is-padding-xsmall has-bg-white">
            <a @click="openGoogleExport(event)" :disabled="!gApiReady || !googleLogged || isExported"
               class="tag text-decoration-none is-medium is-radiusless is-white is-padding-left-xsmall is-padding-right-xsmall">
              <span class="is-size-5">Exporter vers Google Agenda</span>
            </a>
          </div>
          <div class="column is-narrow is-border-right control is-padding-xsmall has-bg-white">
            <a :href="icsUrl" target="_blank" :disabled="isExported"
               class="tag text-decoration-none is-medium is-radiusless is-white is-padding-left-xsmall is-padding-right-xsmall">
              <span class="is-size-5">Exporter vers un autre agenda <span class="is-hidden-desktop-only">(format ICS)</span> <span class="is-hidden-widescreen">(ics)</span></span>
            </a>
          </div>
          <div class="column is-narrow control is-padding-top-small">
            <span class="is-size-3 is-margin-left-xsmall" v-helper.left.medium="'6MZ06ZNTMIqQCQkKcOWW0u'">
              <i class="fas fa-question-circle has-text-grey"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- else -->
      <div class="dayeventactions-actions display-none-rdv" v-else></div>

      <!-- RDV Reporting -->
      <div v-if="(isDone || isOpen) && mode === 'qualification'"
           class="column is-12 is-paddingless dayeventactions-actions">
        <div v-if="event.successful && (!event.reports || !event.reports.length)" class="column is-border-top">
          Félicitation, dites-nous en plus. Votre contact est:
          <div
            class="column is-8 is-padding-left-large is-padding-right-xsmall is-paddingless-bottom columns is-variable is-2 is-multiline">
            <div v-if="report" v-for="(report, idx1) in calendarReports" :key="'reportN1'+idx1"
                 class="column is-3 is-paddingless-top is-paddingless-bottom is-padding-right-xsmall is-paddingless-left">
              <input class="checkradiocase is-primary is-fullwidth" type="radio"
                     v-model="reportN1"
                     :id="report.type + event.pk"
                     :name="report.type + event.pk"
                     :value="report">
              <label class="is-uppercase" :for="report.type + event.pk">{{report.label}}</label>
            </div>
          </div>
          <div v-if="reportN1"
               class="column is-8 is-padding-top-xsmall is-padding-left-large is-padding-right-xsmall is-paddingless-bottom columns is-variable is-2 is-multiline">
            <div v-if="subReport" v-for="(subReport, idx2) in reportN1.children" :key="'reportN2'+idx2"
                 class="column is-3 is-paddingless-top is-padding-bottom-xsmall is-padding-right-xsmall is-paddingless-left">
              <input class="checkradiocase is-primary is-fullwidth" type="radio"
                     v-model="reportN2"
                     :id="subReport.type"
                     :name="subReport.type"
                     :value="subReport">
              <label class="is-uppercase" :for="subReport.type">{{subReport.label}}</label>
            </div>
          </div>
          <div class="columns is-multiline is-border-top has-bg-light" v-if="showNote">
            <div class="column is-12 is-padding-top-small is-padding-bottom-small">
              <label class="label">Note :</label>
            </div>
            <div class="column is-12 is-paddingless-top">
              <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
                <div class="control">
                  <wysiwyg-editor :model="reportNote" placeholder="" :submited='isSubmited'
                                  @change="val => updateNote(val)" :light='true'
                                  :class="{'editr--hide-toolbar':!displayToolbar}"
                                  class="editr--bottom-toolbar editr--height-small content has-bg-white"/>
                </div>
              </div>
              <p v-if="noteError" class="help is-danger">Maximum 255 charactères dans le champs note</p>
            </div>
          </div>
          <div v-if="displaySaveReportButton"
               class="column is-12 is-padding-top-xsmall is-padding-left-xsmall is-padding-right-xsmall is-paddingless-bottom columns is-variable is-2 is-multiline">
            <a class="button is-success is-square is-margin-right-xxsmall" @click="showNote = !showNote"><i
              class="far fa-comment-alt"></i></a>
            <a @click="saveReport" class="button is-success">Enregistrer compte rendu</a>
          </div>
        </div>
        <div v-else-if="event.successful && event.reports && event.reports.length" class="column">
          <!-- <b>Compte rendu de rendez-vous effectué</b><br> -->
          <p v-if="reportN1">{{event.contact_name}} est <b>{{reportN1.label}}.</b></p>
          <p v-if="reportN1 && reportN2">{{reportN1.type === 'interested'  ? 'Action' : 'Information'}}: <b>{{reportN2.label}}</b>.</p>
          <div class="columns is-gapless">
            <p v-if="reportNote" class="column is-narrow"><b>Note</b> :&nbsp;</p>
            <p class="column"><span v-html="reportNote"></span></p>
          </div>
          <p v-if="futureRdv && !loadingFutureRdv">
            Nouveau rendez-vous <b>{{futureRdv.rdv_type}}</b> fixé le
            <a @click="goToDay(futureRdv.date)" class="is-underline"><b> {{futureRdv.date|date}}</b></a>
          </p>
          <div v-if="!futureRdv && reportN2 && reportN2.action && !loadingFutureRdv"
               class="column is-12 is-padding-top-small is-paddingless-left is-padding-right-xsmall is-paddingless-bottom">
            <router-link :to="{name: 'CalendarCreate', query: {returnId: event.pk, page: page ,duplicateEvent: event.pk}}"
                         class="button is-primary">
              <span>Planifier nouveau rendez-vous</span>
            </router-link>
            <a data-tooltip="ajouter rappel" class=" tooltip is-tootltip-primary is-tooltip-right button is-square is-danger is-square has-hover-black" @click="newReminder('newRdv')">
              <span class="icon is-small"><i class="fas fa-alarm-clock is-size-5"></i></span>
            </a>
          </div>
        </div>
        <div v-else-if="event.deferred" class="column">
          <b>Rendez-vous reporté !</b><br>
          <p v-if="reportNote"><b>Note</b> : <span v-html="reportNote"></span></p>
          <div v-if="!futureRdv && !loadingFutureRdv"
               class="column is-12 is-padding-left-xsmall is-padding-right-xsmall is-paddingless-bottom columns is-variable is-2 is-multiline">
              <div class="control">
                <router-link :to="{name: 'CalendarCreate', params: {id: event.pk}, query: {returnId: event.pk, page: page ,duplicateEvent: event.pk, reporter: true}}"
                         class="button is-primary">
                  Reporter le rendez-vous
                </router-link>
                <a data-tooltip="ajouter rappel" class=" tooltip is-tootltip-primary is-tooltip-right button is-square is-danger is-square has-hover-black" @click="newReminder('repportRdv')">
                  <span class="icon is-small"><i class="fas fa-alarm-clock is-size-5"></i></span>
                </a>
                <a class="button is-success is-square " @click="openNewCommentQuickview()">
                <i class="far fa-comment-alt"></i></a>
              </div>
            </div>
          </div>
          <p v-else-if="futureRdv && !loadingFutureRdv">
            Nouveau rendez-vous <b>{{futureRdv.rdv_type}}</b> fixé le
            <a @click="goToDay(futureRdv.date)" class="is-underline"><b> {{futureRdv.date|date}}</b></a>
          </p>
          <div v-else-if="event.canceled" class="column">
            <b>Rendez-vous annulé.</b><br>
            <p v-if="reportNote"><b>Note</b> : <span v-html="reportNote"></span></p>
            <a class="button is-success is-square is-margin-right-small is-margin-top-xsmall"
              @click="openNewCommentQuickview()"><i class="far fa-comment-alt"></i></a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { debounce, isNil, compact } from 'lodash'
  import moment from 'moment'
  import { mapGetters, mapState } from 'vuex'
  import { DefaultValues, GoogleMx } from '@/mixins'

  export default {
    name: 'CalendarRdvItemOld',
    mixins: [DefaultValues, GoogleMx],
    props: {
      event: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      selectedEvent: String,
      page: Number,
      rdvs: {
        type: Array
      }
    },
    data () {
      return {
        // canChange: true,
        edit: false,
        // hasBeenEdit : null,
        // qualiBeforeSave: null,
        eventDate: null,
        mode: null,
        configDate: {
          altInput: true,
          altFormat: 'j M Y H:i',
          dateFormat: 'Z',
          time_24hr: true,
          enableTime: true
        },
        qualificationBefore: {
          canceled: false,
          deferred: false,
          successful: false
        },
        formatedDate: null,
        loading: false,
        activeActionsMenu: false,
        askDelete: false,
        reportN1: null,
        reportN2: null,
        futureRdv: null,
        displayQualif: false,
        loadingFutureRdv: false,
        showNote: false,
        displayToolbar: false,
        noteError: false,
        tooltip: false,
        reportNote: null
      }
    },
    watch: {
      isOpen (v) {
        if (!v) this.activeActionsMenu = false
      },
      selectedEvent (v) {
        if (v !== this.event.pk) this.activeActionsMenu = false
      },
      reportN1 () {
        if (!this.isReported) {
          this.reportN2 = null
        }
      },
      event () {
        return this.init()
      },
      quickview ({mode, params, results}) {
        if (results && params.source.event === this.event.pk) {
          if (mode === 'NEW_NOTE') {
            this.showNote = true
            this.addNote(results)
          }
        }
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isAdmin', 'isSectorManager', 'isManager', 'isOperator', 'currentUserPk', 'googleCalendarsId']),
      eventPk () {
        return this.event.pk
      },
      displayActionButton () {
        return this.isDone && (this.isReported || this.futureRdv || this.event.canceled)
      },
      icsUrl () {
        const apiUrl = this.$configs.APIROOT
        const rdvPk = this.event.pk
        return `${apiUrl}/ical/${rdvPk}`
      },
      isValidRdv () {
        return ['R0', 'R1', 'R2', 'R3'].includes(this.event.rdv_type.toUpperCase())
      },
      isRdv () {
        return this.type === 'RDV'
      },
      isMyRdv () {
        return [this.event.author.pk || this.event.author, this.event.seller.pk || this.event.seller].includes(this.currentUserPk)
      },
      isDone () {
        return this.event.successful || this.event.deferred || this.event.canceled
      },
      isReported () {
        return !!this.event.reports && !!this.event.reports.length
      },
      isInMyCalendar () {
        return this.googleCalendarsId.includes(this.event.google_calendar_id)
      },
      isExported () {
        return isNil(this.event.google_event_id) === false && isNil(this.event.google_calendar_id) === false
      },
      isFutureRdv () {
        return moment(this.event.date).format('x') > moment().format('x')
      },
      canExport () {
        return !this.isExported
      },
      canEdit () {
        if (this.isExported && this.googleLogged) {
          return (this.isAdmin || this.isSectorManager || this.isManager || this.isOperator || this.isMyRdv) && this.isInMyCalendar
        } else {
          return this.isAdmin || this.isSectorManager || this.isManager || this.isOperator || this.isMyRdv
        }
      },
      displaySaveReportButton () {
        return !isNil(this.reportN1) && (isNil(this.reportN1.children) || !isNil(this.reportN2))
      },
      showQuali () {
        if (((this.isDone && !this.displayQualif) || this.isOpen) && this.mode === 'qualification') {
          return true
        } else {
          return false
        }
      },
      // qualification: {
      //   get: function () {
      //     if (this.event.canceled) return 'canceled'
      //     else if (this.event.deferred) return 'deferred'
      //     else if (this.event.successful) return 'successful'
      //   },
      //   set: function (val) {
      //     let result = {
      //       canceled: false,
      //       deferred: false,
      //       successful: false
      //     }
      //     result[val] = true
      //     this.event = Object.assign(this.event, result)
      //   }
      // },
      qualification: {
        get: function () {
          if (this.qualificationBefore.canceled) return 'canceled'
          else if (this.qualificationBefore.deferred) return 'deferred'
          else if (this.qualificationBefore.successful) return 'successful'
        },
        set: function (val) {
          this.edit = true
          let result = {
            canceled: false,
            deferred: false,
            successful: false
          }
          result[val] = true
          this.qualificationBefore = Object.assign(this.qualificationBefore, result)
        }
      },
      prettyDate () {
        if (this.date) {
          let begin = this.date.format('[Le] DD MMMM [de] HH:mm')
          let end = this.endDate ? this.endDate.format(' [à] HH:mm') : ' '
          return `${begin} ${end}`
        }
      },
      date () {
        let date = moment(this.event.date)
        if (date && date.isValid()) return date
        else return null
      },
      endDate () {
        let date = this.event.end_date ? moment(this.event.end_date) : null
        return date && date.isValid() ? date : null
      },
      myCalendarStatus () {
        if (this.currentUserPk === this.event.seller) return 'Participant'
        else if (this.event.guests.length && this.event.guests.includes(this.currentUserPk)) return 'Invité'
        else return null
      },
      myCalendarStatusTag () {
        if (this.myCalendarStatus === 'Participant') return 'is-info'
        else if (this.myCalendarStatus === 'Invité') return 'is-optionne'
        else return null
      }
    },
    methods: {
      addNote (comment) {
        this.reportNote = comment
        this.reportNote.length > 255 ? this.noteError = true : this.noteError = false

        if (!this.noteError) {
          let data = {
            pk: this.event.pk,
            date: this.event.date,
            report_note: this.reportNote
          }
          this.patchRdv(data, true)
        }
      },
      openNewCommentQuickview () {
        let params = {
          source: {
            note: this.reportNote,
            event: this.eventPk
          }
        }
        this.$store.commit('setQuickview', {mode: 'NEW_NOTE', params})
      },
      newReminder (val) {
        let defaultTitleRdv
        if (val === 'repportRdv') defaultTitleRdv = 'Reporter le rendez-vous avec ' + this.event.contact_name
        if (val === 'newRdv') defaultTitleRdv = 'Planifier nouveau rendez-vous avec ' + this.event.contact_name
        let params = {
          defaultTitle: defaultTitleRdv
        }
        this.$store.commit('setQuickview', {mode: 'NEW_REMINDER', params})
      },
      init () {
        this.eventDate = new Date(this.event.date)
        this.reportNote = this.event.report_note
        this.getFutureRdv()

        if (this.event.reports && this.event.reports.length) {
          if (this.event.reports[0]) {
            this.reportN1 = this.calendarReports.find(x => x.type === this.event.reports[0].type)
            if (this.reportN1 && this.event.reports[1]) {
              this.reportN2 = this.reportN1.children.find(x => x.type === this.event.reports[1].type)
            }
          }
          if (this.event.successful) {
            this.displayQualif = true
          }
        }
        if (this.event.canceled) {
          this.displayQualif = true
        }
        if (this.isDone || this.displayQualif) this.mode = 'qualification'
      },
      updateNote (val, note) {
        this.reportNote = val
        this.reportNote.length > 255 ? this.noteError = true : this.noteError = false
      },
      editRdv () {
        this.$router.push({name: 'CalendarEdit', params: {id: this.event.pk}, query: {returnId: this.event.pk, page: this.page}})
      },
      qualifyRdv: debounce(function (e) {
        if (this.canEdit) {
          // this.edit = true
          // let quali = {
          //   successful: 'successful',
          //   deferred: 'deferred',
          //   canceled: 'canceled'
          // }
          let data = {
            successful: false,
            deferred: false,
            canceled: false
          }
          // console.log(e)
          data[e] = true
          delete data.google_calendar_id
          delete data.google_event_i
          // this.patchRdv(data)

          // this.qualiBeforeSave = quali[e]
        }
      }, 500),
      updateItem (e) {
        console.log(e)
        let result = {
          canceled: false,
          deferred: false,
          successful: false
        }
        result[e] = true
        this.event = Object.assign(this.event, result)
        // let data = {
        //   successful: false,
        //   deferred: false,
        //   canceled: false
        // }
        // data[e] = true
        // delete data.google_calendar_id
        // delete data.google_event_i
        this.patchRdv(result)
      },
      cancelEditItem () {
        this.edit = false
        this.qualificationBefore = {
          canceled: false,
          deferred: false,
          successful: false
        }
      },
      openEvent (mode) {
        if (this.isOpen && mode === this.mode) {
          this.closeEvent()
        } else {
          this.mode = mode
          this.$emit('openEvent', this.event)
        }
        this.setFocus()
      },
      closeEvent () {
        this.mode = null
        this.$emit('openEvent', null)
      },
      deleteEvent () {
        const eventPk = this.event.pk
        let key = moment(this.event.date).format('DD/MM/YYYY')
        this.$api.rdvService.delete(this.event.pk).then(r => {
          this.$notify({type: 'is-success', text: 'Rdv Supprimé'})
          this.$store.commit('removeCalendarEvent', {eventPk, key, type: 'rdvs'})
          this.$emit('delete-event', this.event)
          if (this.event.google_event_id) {
            this.removeRdvInGoogle(this.event)
          }
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la suppression'
          })
        })
      },
      activeMenu () {
        this.activeActionsMenu = !this.activeActionsMenu
        this.$emit('selectedEvent', this.event.pk)
      },
      confirmDelete () {
        return this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer cet élément ?',
          confirmButtonText: 'Supprimer'
        })
      },
      saveReport () {
        this.isSubmited = true
        let data = {
          pk: this.event.pk,
          date: this.event.date,
          reports: compact([
            this.reportN1 && this.reportN1.type ? {type: this.reportN1.type} : null,
            this.reportN2 && this.reportN2.type ? {type: this.reportN2.type, action: this.reportN2.action} : null
          ]),
          report_note: this.reportNote
        }
        this.patchRdv(data, true)
      },
      patchRdv (data, cp = false) {
        // cp : Compte rendu
        let rdvPk = this.event.pk
        this.showNote = false
        let key = moment(this.event.date).format('DD/MM/YYYY')
        this.$api.rdvService.patch(rdvPk, data)
          .then(async r => {
            // if (!r.data.deferred) this.closeEvent()
            // this.canChange = false
            this.edit = false
            this.displayQualif = false
            // this.hasBeenEdit = true
            this.$store.commit('addCalendarEvent', {event: r.data, key, type: 'rdvs'})
            this.$emit('updateRdv', r.data)
            this.$notify({
              type: 'is-success',
              text: cp ? 'Compte rendu enregistré.' : 'Rdv qualifié.'
            })
            if (this.event.deferred) {
              await this.getFutureRdv()
              if (!this.futureRdv) {
                this.patchRdvInGoogle(r.data, {summary: `[REPORTÉ] ${r.data.title}`})
              }
            }
            if (this.event.canceled) {
              this.patchRdvInGoogle(r.data, {summary: `[ANNULÉ] ${r.data.title}`})
            }
            if (this.displayActionButton) {
              this.deleteSynchroGoogle(r.data)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      updateRdv (data, silent = false) {
        this.$api.rdvService.put(data.pk, data).then(r => {
          this.$emit('openEvent', null)
          let rdv = r.data
          let key = moment(rdv.date).format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', {event: rdv, key, type: 'rdvs'})
          if (!silent) {
            this.$notify({
              type: 'is-success',
              text: 'Rdv modifié.'
            })
          }
        })
      },
      newRdv () {
        if (this.reportNote) {
          let data = {report_note: this.reportNote}
          this.patchRdv(data, true)
        }
        let newDate = moment.utc(moment(this.formatedDate).toDate())
        let newRdv = Object.assign({}, this.event)
        newRdv.report_note = null
        newRdv.reports = []
        newRdv.successful = false
        newRdv.deferred = false
        newRdv.canceled = false
        delete newRdv.google_calendar_id
        delete newRdv.google_event_id
        newRdv.previous_rdv = this.event.pk
        newRdv.date = newDate.toDate()
        let duration = moment(this.event.end_date).diff(moment(this.event.date), 'hours', true).toFixed(1)
        newRdv.end_date = newDate.clone().add(Number(Math.round(duration)), 'hours').toDate()
        this.$nextTick(() => {
          this.$api.rdvService.post(newRdv).then(r => {
            let createdRdv = r.data
            this.$emit('addEvent', createdRdv)
            this.$store.commit('addCalendarEvent', {
              event: createdRdv,
              key: moment(createdRdv.date).format('DD/MM/YYYY'),
              type: 'rdvs'
            })
            if (this.event.deferred) {
              this.removeRdvInGoogle(this.event)
              this.createRdvInGoogle(createdRdv, this.event.google_calendar_id)
              this.deleteSynchroGoogle(this.event)
            }
            this.getFutureRdv()
            this.$notify({
              type: 'is-success',
              text: 'Rdv reporté.'
            })
          }).catch(() => {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur Le rendez-vous n\'a pas pu être reporté'
            })
          })
        })
      },
      setFocus () {
        // Permet de deplacer le focus pour eviter corriger des problemes visuel
        document.getElementById(`${this.event.pk}'-action-menu'`).focus()
        document.getElementById(`${this.event.pk}'-action-menu'`).blur()
      },
      goToDay (e) {
        let queryString = `day=${moment(e).format('DD')}&month=${moment(e).format('MM')}&year=${moment(e).format('YYYY')}`
        this.$router.push(`?${queryString}`)
      },
      async getFutureRdv () {
        if (!this.rdvs.map(x => x.previous_rdv).includes(this.event.pk)) {
          this.loadingFutureRdv = true
          if ((this.event.successful && this.event.reports && this.event.reports.length) || this.event.deferred) {
            const {data} = await this.$api.rdvService.get({previous_rdv: this.event.pk})
            this.futureRdv = data.items.length ? data.items[0] : null
            this.displayQualif = true
          }
          this.loadingFutureRdv = false
        }
      }
    },
    created () {
      this.isSubmited = false
      this.init()
      if (this.isExported && this.googleLogged && this.googleCalendarsId.includes(this.event.google_calendar_id)) {
        this.googleSync(this.event)
      }
    }
  }
</script>

<style>
  .display-none-rdv {
    display: none
  }

  .margin-left-rdv {
    margin-left: 90px
  }

  .text-decoration-none {
    text-decoration: none !important
  }

  .text-decoration-none:hover {
    text-decoration: none !important
  }

  .rdv-button a{
    border-radius: 0px;
    height: 49px;
    width: 49px !important;
    border: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarRdvItemOld.vue